export default __webpack_public_path__ + "static/media/dockerPush.8c201434.svg";